export const getOptions = async (service, keyword, groupId, orgId) => {
  const options = await service.getAutoSuggestions(`/group/users?keyword=${keyword}`);
  return options;
};
